/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'./../InteractionFactory',
	'./../SelectionAction',
	'./../ExpandAction'
], function(Class, InteractionFactory, SelectionAction, ExpandAction) {

	const Common = Class.extend({

		init: function(logger, dashboardApi) {
			Common.inherited('init', this, arguments);

			this.logger = logger;
			this._dashboardApi = dashboardApi;
		},

		destroy: function () {
			if (this._interactions) {
				for (let name in this._interactions) {
					if (this._interactions.hasOwnProperty(name)) {
						const interaction = this._interactions[name].wrapped;
						if (interaction && interaction.destroy) {
							interaction.destroy();
						}
					}
				}
				this._interactions = null;
			}
		},

		getInteraction: function(name){
			const interaction = this._interactions[name];
			return interaction && interaction.wrapped;
		},

		attachInteractions: function (controller) {
			return this._getInteractions(controller)
				.then((interactions) => {
					this._interactions = interactions;
					this._attachInteractions(controller, interactions);
				});
		},

		// Private

		_attachInteractions: function(controller, interactions) {
			const {
				selection,
				expand
			} = interactions;

			if (selection) {
				controller.addActionForSelector(selection, '.page .widget');
				controller.addActionForSelector(selection, '.page .pagegroup');
			}

			if(expand) {
				const focusModeEnabled = !(controller.config && controller.config.focusModeDisabled === true);
				if (focusModeEnabled) {
					controller.addActionForSelector(expand, '.page .widget.liveWidget:not(.eventGroupMode *)');
				}
			}
		},

		_getInteractions: function(controller) {
			const interactions = {
				selection: SelectionAction,
				expand: ExpandAction
			};

			const factory = new InteractionFactory(controller);

			return factory.getInteractions(interactions);
		}

	});

	return Common;
});
